import { useMemo, useState } from 'react'
import useTrans from '@hooks/useTrans'
import { Button, ResultsLabel, WContainer } from '@components/atoms'
import { ChipsBarResults, MagazineCardGrid } from '@components/organisms'
import styles from './MagazineListing.module.sass'

interface Props {
  news?: any[]
  categorie?: any[]
  className?: string
}

const MagazineListing = (props: Props) => {
  const { news = [], categorie = [], className = '' } = props

  const t = useTrans()

  const step = 6
  const [selectedChip, setSelectedChip] = useState(null)
  const [visibleItemsCount, setVisibleItemsCount] = useState(step)

  const loadMore = () => {
    setVisibleItemsCount((prevCount) => prevCount + step)
  }

  const processedResults = useMemo(() => {
    const cards =
      news.filter((child) => {
        if (selectedChip === null) {
          return true
        }
        return child.tag === selectedChip.title
      }) || []

    return { visibleItems: cards.slice(0, visibleItemsCount), items: cards }
  }, [selectedChip, news, visibleItemsCount])

  return (
    <div className={`${styles.root} ${className}`}>
      <ChipsBarResults
        categorie={categorie}
        selectedChip={selectedChip}
        setSelectedChip={setSelectedChip}
        results={processedResults?.items.length}
      />
      {!!news?.length && (
        <>
          <WContainer>
            <h3 className={styles.title}>{selectedChip?.title || t('Tutte le categorie')}</h3>
          </WContainer>
          <MagazineCardGrid news={processedResults?.visibleItems} className={styles.cardGrid} />
        </>
      )}
      {processedResults?.visibleItems?.length > 0 && (
        <WContainer>
          <div className={styles.pagination}>
            <ResultsLabel
              num={processedResults?.visibleItems?.length}
              tot={processedResults?.items?.length}
            />
            {processedResults?.visibleItems?.length < processedResults?.items?.length && (
              <Button onClick={loadMore} variant="ghost" label={t('Mostra di più')} />
            )}
          </div>
        </WContainer>
      )}
    </div>
  )
}

export default MagazineListing
